export default __webpack_public_path__ + "36fb1759f9b3e2b47b75579c7cc909a9.svg";